// extracted by mini-css-extract-plugin
module.exports = {"rowC":"departmentsStatusPage_rowC__2UzhD","partframe":"departmentsStatusPage_partframe__2df-I"};